import type { AtomModel } from '@models/atom.model';

import type { TableEditorLabelsColumnData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<TableEditorLabelsColumnData>;
};

export const LabelsSettingsModal = ({ atom }: Props) => {
  atom;
  return <></>;
};
